'use client';

;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import clsx from 'clsx';
import { PropsWithChildren, useId, useState } from 'react';
import { ChevronDownIcon } from '@/public/assets/svg';
type Props = PropsWithChildren<{
  title: string;
}>;
const EASE_OUT = 'ease-[cubic-bezier(0.23,1,0.32,1)]';
const FooterColumn = ({
  title,
  children
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const panelId = useId();
  return <div className="border-b border-gray-200 first:border-t md:border-0 md:first:border-t-0" data-sentry-component="FooterColumn" data-sentry-source-file="index.tsx">
      <button type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setIsOpen(currentValue => !currentValue)} className="text-h8 flex w-full items-center justify-between py-4.5 text-left font-bold text-gray-600 transition-opacity duration-150 active:opacity-60 md:hidden">
        {title}
        <ChevronDownIcon className={clsx('h-5 w-5 transition-transform duration-200', EASE_OUT, {
        'rotate-180': isOpen
      })} data-sentry-element="ChevronDownIcon" data-sentry-source-file="index.tsx" />
      </button>
      <p className="text-h8 mb-6 hidden font-bold text-gray-600 md:block lg:mb-8">{title}</p>

      {/* Links stay in the DOM when closed so crawlers still see them; `visibility`
          keeps them out of the tab order and stays visible for the whole close. */}
      <div id={panelId} className={clsx('grid transition-[grid-template-rows,visibility] motion-reduce:transition-none md:visible md:grid-rows-[1fr] md:transition-none', EASE_OUT, isOpen ? 'visible grid-rows-[1fr] duration-[280ms]' : 'invisible grid-rows-[0fr] duration-[240ms]')}>
        <div className="min-h-0 overflow-hidden">
          <div className={clsx('pb-2 transition-[opacity,transform] duration-200 motion-reduce:translate-y-0 md:translate-y-0 md:pb-0 md:opacity-100 md:transition-none', EASE_OUT, isOpen ? 'translate-y-0 opacity-100' : '-translate-y-1 opacity-0')}>
            {children}
          </div>
        </div>
      </div>
    </div>;
};
export default FooterColumn;